import {Link} from 'react-router-dom';
import Message from '../../components/message/Message';
import MetaTags from '../../components/common/MetaTags';
import PropTypes from 'prop-types';
import React from 'react';
import StickyHeader from '../../components/tutorial/StickyHeader';
import TutorialModSection from '../../components/tutorial/TutorialModSection';
import TutorialStore from '../../stores/TutorialStore';
import {connectToStores} from 'epic-alt-utils/index';
import {generateRoutePath} from '@epic-core/common';

@connectToStores
export default class ModTutorialDetailView extends React.Component {
    static propTypes = {
        tutorialStore: PropTypes.object, //eslint-disable-line
        match: PropTypes.object
    };
    static getStores() {
        return [TutorialStore];
    }

    static getPropsFromStores() {
        return {
            tutorialStore: TutorialStore.getState()
        };
    }

    renderContent = (objective) => {
        return objective.map(({steps = []}) => {
            return steps.length > 0 && steps.map((item, key) => <TutorialModSection content={item.content} key={key} />)
        })
    }
    

    render() {
        const list = this.props.tutorialStore.modTutorialList || [];
        const slug = this.props.match.params.title;
        const tutorialDetail = list.find((item) => item._slug === slug);
        const {_title, headerImage, tutorial = {}} = tutorialDetail;
        const {completionTime, name, overview, summary, objective = []} = tutorial
        return (
            <div className="mod-tutorial-detail-view">
                <MetaTags meta={{title: _title}} />
                <StickyHeader title={name} backUrl="/tutorials" time={completionTime} image={headerImage} />
                <div className="mod-tutorial-content">
                    {overview && <TutorialModSection content={overview} />}
                    {objective.length > 0 && this.renderContent(objective)}
                    {summary && <TutorialModSection content={summary} />}
                    <Link className="back-link" to={generateRoutePath('tutorials')}><Message code="epic.ut.tutorial.back.mod" /></Link>
                </div>
            </div>
        );
    }
}
